import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import cx from "classnames";
import s from "./EmailVerificationModal.css";
import cs from "../../components/commonStyle.css";
import { Modal, FormGroup, Button } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { closeEmailVerificationModal } from "../../actions/modalActions";
import { Field, reduxForm } from "redux-form";
import messages from "../../locale/messages";
import VerificationSuccess from "../VerificationSuccess/VerificationSuccess";
import { getVerificationMessageBody } from "../../helpers/verificationMessageHelper";
import VerificationFailedModal from "../VerificationFailedModal/VerificationFailedModal";
import VerificationLoaderModal from "../VerificationLoaderModal/VerificationLoaderModal";
import { sendEmail } from "../../core/email/sendEmail";

// Update validation function to use validationMessages
const validate = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = messages.required;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = messages.invalidEmail;
  }
  return errors;
};



class EmailVerificationModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    url: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
  };

  state = {
    showSuccessModal: false,
    isSubmitting: false,
    error: null,
    showLoaderModal: false,
    showFailedModal: false,
    submittedEmail: '',
    };

  submitForm = async (values) => {
    const { url } = this.props;
    console.log(url, "url");
    if (!values || !values.email) {
      return;
    }

    // Build content for ID verification email
    const content = {
      verificationUrl: url, // the verification link to send
      email: values.email,
      name: values.name || values.email.split('@')[0], // fallback to prefix if name not present
      // Optional: add any extra info you want to show in the email
    };

    this.setState({ isSubmitting: true, error: null });
    this.setState({ showLoaderModal: true });
    this.setState({ showFailedModal: false });
    try {
      // const response = await fetch(
      //   `/api/qrcode/send-email`,
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify(getVerificationMessageBody(values.email, url, 'email')),
      //   }
      // );

      // const data = await response.json();

      // if (!response.ok) {
      //   throw new Error(data.error || "Failed to send email");
      // }
     const emailResponse = await sendEmail(values.email, 'IdVerificationEmail', content);
console.log(emailResponse,"emailResponse");

if (emailResponse && emailResponse.status === 200) {
  this.setState({ 
    showSuccessModal: true, 
    showFailedModal: false, 
    submittedEmail: values.email 
  });
  this.props.onClose();
} else {
  // If not 200, show failed modal
  this.setState({
   // error: messages.emailVerificationFailed,
    showFailedModal: true,
    showSuccessModal: false
  });
}
    } catch (error) {
      console.error("Email sending error:", error);
      this.setState({
        error: messages.emailVerificationFailed,
        showFailedModal: true,
        showSuccessModal: false
      });
    } finally {
      this.setState({ isSubmitting: false });
      this.setState({ showLoaderModal: false });
    }
  };

  handleSuccessClose = () => {
    this.setState({ showSuccessModal: false }, () => {
      window.location = '/dashboard';
    });
  };

  handleLoaderClose = () => {
    this.setState({ showLoaderModal: false });
  };

  handleFailedClose = () => {
    this.setState({ showFailedModal: false });
  };

  renderFormControl = ({
    input,
    label,
    type,
    meta: { touched, error },
    className,
    maxLength,
  }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx("inputFocusColor", cs.positionRelative)}>
        <label>{label}</label>
        <input
          {...input}
          placeholder={label}
          type={type}
          className={className}
          maxLength={maxLength}
        />
        {touched && error && (
          <span className={cs.errorMessage}>
            {error && formatMessage(error)}
          </span>
        )}
      </div>
    );
  };

  render() {
    const { onClose, show, handleSubmit, intl } = this.props;
    const { showSuccessModal, isSubmitting, error, showLoaderModal, showFailedModal } = this.state;

    return (
      <div>
        <Modal
          show={show}
          animation={false}
          onHide={onClose}
          className="verificationModal"
        >
          <div className={cx(s.sectionBlock)}>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <div className={s.verificationContent}>
                <h2 className={cx(s.titleText)}>
                  <FormattedMessage {...messages.emailVerificationTitle} />
                </h2>
                <p className={cx(s.contentText)}>
                  <FormattedMessage {...messages.emailVerificationInstruction} />
                </p>
                <form onSubmit={handleSubmit(this.submitForm)}>
                  <FormGroup className={cs.spaceBottom3}>
                    <Field
                      name="email"
                      type="email"
                      component={this.renderFormControl}
                      label={intl.formatMessage(messages.emailVerificationLabel)}
                      className={cx(
                        cs.formControlInput,
                        "commonInputPaddingRTL",
                        "form-control"
                      )}
                      maxLength={255}
                    />
                    {error && <span className={cs.errorMessage}>{error}</span>}
                  </FormGroup>
                  <Button
                    className={cx(
                      cs.btnPrimary,
                      cs.fullWidth,
                      cs.commonMediumText
                    )}
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? intl.formatMessage(messages.emailVerificationSending) : intl.formatMessage(messages.emailVerificationSend)}
                  </Button>
                </form>
              </div>
            </Modal.Body>
          </div>
        </Modal>

        <VerificationSuccess
          show={showSuccessModal}
          onClose={this.handleSuccessClose}
          emailOrPhone={this.state.submittedEmail}
        />
        <VerificationLoaderModal
          show={showLoaderModal}
          onClose={this.handleLoaderClose}
        />
        <VerificationFailedModal
          show={showFailedModal}
          onClose={this.handleFailedClose}
        />
      </div>
    );
  }
}

EmailVerificationModal = reduxForm({
  form: "EmailVerificationForm",
  validate,
  destroyOnUnmount: true,
})(EmailVerificationModal);

const mapState = (state) => ({
  emailVerificationModal: state.modalStatus.isEmailVerificationModalOpen,
});

const mapDispatch = {
  closeEmailVerificationModal,
};

export default injectIntl(
  withStyles(s, cs)(connect(mapState, mapDispatch)(EmailVerificationModal))
);
